import { PipelinesPage } from '@/pages/crm/settings/pipelines/PipelinesPage';
import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/crm/settings/pipelines/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['crmConfig.managePipelines'], redirectTo: '/dashboard' }),
	component: PipelinesPage,
});
